module.exports = __webpack_public_path__ + "static/UnclickCommon-fba78b21a5c829f5c49c6d6b4e43e239.png";